// extracted by mini-css-extract-plugin
export default {"root":"pagination_root__5j7mo","outlined":"pagination_outlined__-40ZG","selected":"pagination_selected__heNJ+"};